import { useContext } from 'react';
import { GlobalConfirmDeleteDialogContext, GlobalConfirmDeleteDialogContextValue } from '../context/GlobalConfirmDeleteDialogContext';
export function useGlobalConfirmDeleteDialog() {
  return useContext(GlobalConfirmDeleteDialogContext);
}